<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'
import { opcoesTipoCriacao, opcoesTipoManejo, opcoesTipoTratamento, opcoesAproveitamentoResiduos } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay,
    Financiamento,
    Descricao
  },
  props: {
    pratica: {
      type: Object
    }
  },
  methods: {
    formataCriacoes (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => {
        if (value.tipoCriacao === 'OUTROS') {
          return `• Tipo de criação: ${value.outrasCriacoes} / Número de animais: ${value.numeroAnimais} / Data de início: ${formataStringYearMonthToBr(value.dataInicio)}`
        }
        return `• Tipo de criação: ${opcoesTipoCriacao.find(tipo => tipo.id === value.tipoCriacao).nome} / Número de animais: ${value.numeroAnimais} / Data de início: ${formataStringYearMonthToBr(value.dataInicio)}`
      })
      return opcoesFormatadas.join('<br /> ')
    },
    formataTipoManejo (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => opcoesTipoManejo.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    },
    formataTipoTratamento (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(v => v !== 'OUTROS').map(value => opcoesTipoTratamento.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    },
    formataAproveitamento (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(v => v !== 'OUTROS').map(value => opcoesAproveitamentoResiduos.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    }
  }
}
</script>

<template>
  <div>
    <div>
      <span class="title-praticas">Dados da prática</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Número de animais por tipo:" :content="formataCriacoes(pratica.criacoes)" :isContentInNextLine="true" />
        <app-display label="Tipo de tratamento:" :content="formataTipoTratamento(pratica.tiposTratamento)" />
        <app-display v-if="pratica.tiposTratamento.length && pratica.tiposTratamento.includes('OUTROS')" label="Outro tipo de tratamento:" :content="pratica.outrosTiposTratamento" />
      </el-col>
      <el-col :span="12">
        <app-display label="Tipo de manejo predominante:" :content="formataTipoManejo(pratica.tiposManejo)" />
        <app-display label="Aproveitamento do resíduo tratado:" :content="formataAproveitamento(pratica.tiposAproveitamentoResiduos)" />
        <app-display v-if="pratica.tiposAproveitamentoResiduos.length && pratica.tiposAproveitamentoResiduos.includes('OUTROS')" label="Outro aproveitamento do resíduo tratado:" :content="pratica.outrosTiposAproveitamentoResiduos" />
      </el-col>
    </el-row>
    <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
    <Descricao :descricao="pratica.descricao" />
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/MRPA/MRPA.vue